import clsx from 'clsx';
import { memo } from 'react';

import type { SharedTopNavProps } from './types';

import { useAppNavBreadcrumbs } from '../../../../context/AppNavBreadcrumbs/AppNavBreadcrumbs';
import { Icon } from '../../../Icon/Icon';
import { AppNavBrandLink } from '../AppNavBrandLink';
import './TopNav.css';

/**
 * The bar across the top of the application: the brand link, the breadcrumb
 * trail, and trailing controls. On narrow viewports it also carries the toggle
 * that opens the navigation drawer.
 */
export const TopNav = memo(function TopNav({
  actions,
  brand,
  dataAttributes,
  menuToggle,
}: SharedTopNavProps) {
  const breadcrumbs = useAppNavBreadcrumbs();

  return (
    <div
      className={clsx('eds-top-nav', menuToggle && 'eds-top-nav--with-toggle')}
      {...dataAttributes}
    >
      {menuToggle && (
        <button
          type="button"
          aria-label={menuToggle.label}
          className="eds-top-nav--toggle"
          title={menuToggle.label}
          {...menuToggle.dataAttributes}
          onClick={menuToggle.onClick}
        >
          <Icon icon="menu" />
        </button>
      )}

      <AppNavBrandLink brand={brand} className="eds-top-nav--brand" />

      {breadcrumbs && (
        <div
          className="eds-top-nav--breadcrumbs"
          data-testid="top-nav-breadcrumbs"
        >
          {breadcrumbs}
        </div>
      )}

      {actions && <div className="eds-top-nav--actions">{actions}</div>}
    </div>
  );
});

TopNav.displayName = 'TopNav';
